<div class="aca-acl">
  <mat-progress-bar mode="indeterminate" *ngIf="loading() || busy()" />

  <!-- ── inheritance ─────────────────────────────────────────────────────── -->
  <section class="aca-acl__card aca-acl__inherit">
    <div class="aca-acl__inherithead">
      <span class="aca-acl__inherittile"><mat-icon>folder_shared</mat-icon></span>

      <div class="aca-acl__inherittext">
        <h3 class="aca-acl__inherittitle">{{ 'DMS.PERMISSIONS.INHERIT_TITLE' | translate }}</h3>

        <p class="aca-acl__inheritsub">
          <mat-icon>groups</mat-icon>
          <span *ngIf="inheritedCount(); else noInherited">{{
            'DMS.PERMISSIONS.INHERIT_SUMMARY' | translate: { p0: inheritedCount() }
          }}</span>
          <ng-template #noInherited>{{ 'DMS.PERMISSIONS.INHERIT_NONE' | translate }}</ng-template>
        </p>

        <button type="button" class="aca-acl__seelink" *ngIf="inheritedCount()" (click)="setFilter('inherited')">
          {{ 'DMS.PERMISSIONS.SEE_INHERITED' | translate }}<mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <mat-slide-toggle
        class="aca-acl__toggle"
        [checked]="inheritEnabled()"
        [disabled]="!canEdit() || busy()"
        (change)="toggleInheritance($event.checked)"
        [attr.aria-label]="'DMS.PERMISSIONS.INHERIT_TITLE' | translate"
      />
    </div>

    <div class="aca-acl__inheritactions">
      <button type="button" class="aca-acl__primary" [disabled]="!canEdit() || busy()" (click)="add()">
        <mat-icon>person_add_alt</mat-icon>{{ 'DMS.UI.617F00' | translate }}
      </button>

      <label class="aca-acl__filter">
        <mat-icon>filter_alt</mat-icon>
        <span class="aca-acl__filterlabel">{{ 'DMS.PERMISSIONS.FILTER' | translate }}</span>
        <select [ngModel]="filter()" (ngModelChange)="setFilter($event)" [attr.aria-label]="'DMS.PERMISSIONS.FILTER' | translate">
          <option *ngFor="let entry of filters" [value]="entry.id">{{ entry.label | translate }}</option>
        </select>
        <mat-icon class="aca-acl__filterchevron">expand_more</mat-icon>
      </label>
    </div>
  </section>

  <!-- ── who may do what ─────────────────────────────────────────────────── -->
  <section class="aca-acl__card aca-acl__list">
    <div class="aca-acl__listhead">
      <mat-icon class="aca-acl__listicon">groups</mat-icon>
      <h3 class="aca-acl__listtitle">{{ 'DMS.UI.8B55A2' | translate }}</h3>
      <span class="aca-acl__count">{{ 'DMS.PERMISSIONS.COUNT' | translate: { p0: visible().length } }}</span>
    </div>

    <div class="aca-acl__empty" *ngIf="!loading() && !visible().length">
      <span class="aca-acl__emptyicon"><mat-icon>group_off</mat-icon></span>
      <p class="aca-acl__emptytitle">{{ 'DMS.PERMISSIONS.EMPTY' | translate }}</p>
      <p class="aca-acl__emptyhint">{{ 'DMS.PERMISSIONS.EMPTY_HINT' | translate }}</p>
    </div>

    <div class="aca-acl__tablewrap" *ngIf="visible().length">
      <table class="aca-acl__table">
        <thead>
          <tr class="aca-acl__headrow">
            <th class="aca-acl__th aca-acl__th--who">{{ 'DMS.PERMISSIONS.COL_WHO' | translate }}</th>
            <th class="aca-acl__th">{{ 'DMS.PERMISSIONS.COL_ROLE' | translate }}</th>
            <th class="aca-acl__th">{{ 'DMS.PERMISSIONS.COL_TYPE' | translate }}</th>
            <th class="aca-acl__th">
              {{ 'DMS.PERMISSIONS.COL_UPDATED' | translate
              }}<mat-icon class="aca-acl__thinfo" [matTooltip]="'DMS.PERMISSIONS.UPDATED_HINT' | translate">info</mat-icon>
            </th>
            <th class="aca-acl__th aca-acl__th--actions">{{ 'DMS.PERMISSIONS.COL_ACTIONS' | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr class="aca-acl__row" *ngFor="let row of paged(); trackBy: trackByAuthority">
            <td class="aca-acl__td">
              <span class="aca-acl__who">
                <span class="aca-acl__avatar" [ngClass]="'aca-acl__avatar--' + row.tone">{{ row.initial }}</span>
                <span class="aca-acl__whotext">
                  <span class="aca-acl__whoname" [title]="row.displayName">{{ row.displayName }}</span>
                  <span class="aca-acl__whokind">{{
                    (row.isGroup ? 'DMS.PERMISSIONS.KIND_GROUP' : 'DMS.PERMISSIONS.KIND_USER') | translate
                  }}</span>
                </span>
              </span>
            </td>

            <td class="aca-acl__td">
              <select
                class="aca-acl__roleselect"
                *ngIf="editing() === row.authorityId; else roleText"
                [ngModel]="row.role"
                (ngModelChange)="changeRole(row, $event)"
                (blur)="cancelEdit()"
                [attr.aria-label]="'DMS.PERMISSIONS.EDIT_ROLE' | translate"
              >
                <option *ngFor="let role of roles()" [value]="role">{{ roleLabel(role) }}</option>
              </select>

              <ng-template #roleText>
                <span class="aca-acl__role">
                  <span class="aca-acl__rolename">{{ row.role }}</span>
                  <span class="aca-acl__rolethai">{{ roleLabel(row.role) }}</span>
                </span>
              </ng-template>
            </td>

            <td class="aca-acl__td">
              <span class="aca-acl__chip" [class.aca-acl__chip--direct]="!row.inherited">
                <mat-icon>{{ row.inherited ? 'groups' : 'person' }}</mat-icon>
                {{ (row.inherited ? 'DMS.PERMISSIONS.TYPE_INHERITED' : 'DMS.PERMISSIONS.TYPE_DIRECT') | translate }}
              </span>
            </td>

            <td class="aca-acl__td">
              <span class="aca-acl__when" *ngIf="row.updatedAt; else noWhen">
                <span class="aca-acl__whenday">{{ row.updatedAt | acaDate: 'd MMM y' }}</span>
                <span class="aca-acl__whentime">{{
                  'DMS.PERMISSIONS.TIME_AT' | translate: { p0: (row.updatedAt | acaDate: 'HH:mm') }
                }}</span>
              </span>
              <ng-template #noWhen><span class="aca-acl__whennone">—</span></ng-template>
            </td>

            <td class="aca-acl__td aca-acl__td--actions">
              <button
                type="button"
                class="aca-acl__act"
                [disabled]="row.readonly || !canEdit() || busy()"
                [matMenuTriggerFor]="rowMenu"
                [matTooltip]="(row.readonly ? 'DMS.PERMISSIONS.READONLY' : 'DMS.PERMISSIONS.COL_ACTIONS') | translate"
                [attr.aria-label]="'DMS.PERMISSIONS.COL_ACTIONS' | translate"
              >
                <mat-icon>more_horiz</mat-icon>
              </button>

              <mat-menu #rowMenu="matMenu" class="aca-acl__menu">
                <button mat-menu-item type="button" (click)="startEdit(row)">
                  <mat-icon>edit</mat-icon>
                  <span>{{ 'DMS.PERMISSIONS.EDIT_ROLE' | translate }}</span>
                </button>
                <button mat-menu-item type="button" class="aca-acl__menudanger" (click)="remove(row)">
                  <mat-icon>delete_outline</mat-icon>
                  <span>{{ 'DMS.PERMISSIONS.DELETE' | translate }}</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="aca-acl__foot" *ngIf="visible().length">
      <label class="aca-acl__pagesize">
        <select [ngModel]="pageSize()" (ngModelChange)="setPageSize($event)" [attr.aria-label]="'DMS.PERMISSIONS.PAGE_SIZE_LABEL' | translate">
          <option *ngFor="let size of pageSizes" [value]="size">{{ 'DMS.PERMISSIONS.PAGE_SIZE' | translate: { p0: size } }}</option>
        </select>
        <mat-icon>expand_more</mat-icon>
      </label>

      <div class="aca-acl__pager">
        <button
          type="button"
          class="aca-acl__pagebtn"
          [disabled]="page() === 1"
          (click)="goToPage(page() - 1)"
          [attr.aria-label]="'DMS.PERMISSIONS.PREV' | translate"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="aca-acl__pagenow">{{ page() }}</span>
        <button
          type="button"
          class="aca-acl__pagebtn"
          [disabled]="page() >= pageCount()"
          (click)="goToPage(page() + 1)"
          [attr.aria-label]="'DMS.PERMISSIONS.NEXT' | translate"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <span class="aca-acl__range">{{
        'DMS.PERMISSIONS.RANGE' | translate: { p0: rangeFrom(), p1: rangeTo(), p2: visible().length }
      }}</span>
    </div>
  </section>
</div>
